export default "__VITE_ASSET__1y0NTJ3y__"